/** @format */

import {useState} from 'react';

import {Unstable_Popup as BasePopup} from '@mui/base/Unstable_Popup';
import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

import PopupBody from './PopupBody';

const PlusBadge = styled('span')(() => ({
  color: '#8B8B8B',
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '16px',
}));

const UsersWrapper = styled(Box)(({theme}) => ({
  padding: theme.spacing(1),
  borderRadius: '8px',
  background: '#202020',
}));

interface Props {
  names: string[];
  isExpanded: boolean;
}

const EmployeesCell = ({names, isExpanded}: Props) => {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  if (isExpanded) {
    if (names.length === 0) {
      return null;
    }
    return (
      <UsersWrapper>
        {names.map((name, index) => (
          <Box key={index}>{name}</Box>
        ))}
      </UsersWrapper>
    );
  }

  const hasMany = names.length >= 2;

  return (
    <Box
      sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}
      onMouseEnter={event => hasMany && setAnchor(event.currentTarget)}
      onMouseLeave={() => setAnchor(null)}
    >
      {names[0] ?? ''}
      {hasMany && <PlusBadge>{`+${names.length - 1}`}</PlusBadge>}

      <BasePopup open={Boolean(anchor)} anchor={anchor}>
        <PopupBody>
          {names.map((name, index) => (
            <Box key={index}>{name}</Box>
          ))}
        </PopupBody>
      </BasePopup>
    </Box>
  );
};

export default EmployeesCell;
